<div class="menu-notifications">

    <h2 class="section-title">Notificaciones</h2>
    <p class="section-intro m-0">Decide qué correos quieres recibir de Citylok.</p>

    <div class="content">

        <section class="section">
            <h3 class="card-title m-0">Por correo</h3>

            <div class="option">
                <span class="option-icon active"><i class="fa-light fa-clock"></i></span>
                <div class="option-body">
                    <p class="m-0 option-section">Recordatorio de tus eventos</p>
                    <p class="m-0 option-help">Te avisamos el día antes de un evento para el que tengas entradas.</p>
                </div>
                <mat-slide-toggle class="toggle-pink" [(ngModel)]="eventReminders"
                    (change)="onToggleChange()"></mat-slide-toggle>
            </div>

            <div class="option-divider"></div>

            <!-- La confirmación y las entradas no se pueden apagar: van con el
                 pedido y sin ellas el comprador se queda sin sus QR. Se enseña
                 para que se vea que existe, pero sin interruptor. -->
            <div class="option option-con-candado">
                <span class="option-icon"><i class="fa-light fa-envelope"></i></span>
                <div class="option-body">
                    <p class="m-0 option-section">Confirmación de compra y entradas</p>
                    <p class="m-0 option-help">Son parte del pedido, así que se envían siempre.</p>
                </div>
                <span class="option-locked">
                    <i class="fa-light fa-lock"></i>
                    Siempre activo
                </span>
            </div>
        </section>

        <!-- Los avisos por intereses de ciudad no llegan a enviarse: el
             interruptor guardaba una preferencia que nadie lee. Se retira de
             la pantalla hasta que exista el envío.
        <div class="section" *ngIf="!oficial">
            <p class="title-section m-0">Usuario</p>
            <mat-divider></mat-divider>

            <div class="option">
                <p class="m-0 option-section">Tus intereses en tu ciudad</p>
                <mat-slide-toggle [(ngModel)]="notifications.city" (change)="onToggleChange()"></mat-slide-toggle>
            </div>
            <mat-divider></mat-divider>

            <div class="option">
                <p class="m-0 option-section">Actividad usuarios que sigues</p>
                <mat-slide-toggle [(ngModel)]="notifications.followed" (change)="onToggleChange()"></mat-slide-toggle>
            </div>
            <mat-divider></mat-divider>

            <div class="option">
                <p class="m-0 option-section">Actividad sitios que sigues</p>
                <mat-slide-toggle [(ngModel)]="notifications.useroficial" (change)="onToggleChange()"></mat-slide-toggle>
            </div>
            <mat-divider></mat-divider>
        </div>
        -->

        <!-- El aviso de venta de entradas es cosa del panel de control, no del
             perfil del comprador, y tampoco se envía.
        <div class="section" *ngIf="oficial || verified">
            <p class="title-section m-0">Creador</p>
            <mat-divider></mat-divider>

            <div class="option">
                <p class="m-0 option-section">Actividad venta entradas</p>
                <mat-slide-toggle [(ngModel)]="notifications.tickets" (change)="onToggleChange()"></mat-slide-toggle>
            </div>
            <mat-divider></mat-divider>
        </div>
        -->

        <div class="save-row" *ngIf="hasChanges">
            <button class="primary-button solid" (click)="saveNotifications()">Guardar cambios</button>
        </div>
    </div>
</div>
